import { connect } from 'react-redux';
import { createCollection } from '../../../../CollectionPanel/redux/actionCreators';
import { getNewFolderNameBlacklist, getIsNewCollectionSaving, } from '../../../../CollectionPanel/redux/selectors';
var mapStateToProps = function (state) { return ({
    folderNameBlacklist: getNewFolderNameBlacklist(state),
    isSaving: getIsNewCollectionSaving(state),
}); };
var mapDispatchToProps = {
    createCollection: createCollection,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NewCollectionPopup.container.js.map